import React, { memo, useEffect } from "react";
import { validators } from "investira.sdk";
import { Stack, Divider } from "investira.react.components";
import ConsultaProvider from "../../../../contexts/ConsultaContext";
import useKickBack from "../../../../hooks/useKickBack";
import withMessage from "../../../../hoc/withMessage";
import PlanoPosicao from "../PlanoPosicao";
import DetalhesErrorMessage from "../DetalhesErrorMessage";
import Highlights from "./Highlights";
import Analise from "./Analise";
import Secoes from "./Secoes";
// import Graphs from "./Graphs";
// import VarTotais from "./VarTotais";

const ConsultaVar = memo((props) => {
  const { data } = props;
  const kick = useKickBack();

  const ativosFiltered = (
    ativos = [],
    filtrarComErro = false,
    atributoErro = "erros"
  ) => {
    if (!Array.isArray(ativos)) return [];

    return ativos.filter((ativo) =>
      filtrarComErro
        ? ativo.hasOwnProperty(atributoErro)
        : !ativo.hasOwnProperty(atributoErro)
    );
  };

  useEffect(() => {
    kick && props.onMessage("Entidade alterada");
  }, [kick]);

  if (validators.isEmpty(data)) {
    return null;
  }

  const xAtivosError = ativosFiltered(data.response.detalhe, true);
  const xAtivosErrorSize = xAtivosError.length;
  const hasError = xAtivosErrorSize > 0;

  return (
    <ConsultaProvider>
      <Stack spacing={2}>
        <PlanoPosicao
          beta={true}
          created={data.request?.data}
          carteira={data.request_metadata?.carteira}
          aberta={data.request.aberta}
        />
        <Divider />
        <DetalhesErrorMessage show={hasError} ativosSize={xAtivosErrorSize} />
        <Stack sx={{ gap: 2 }} component="section">
          <Stack gap={2} flexGrow={1} direction={{ xs: "column", md: "row" }}>
            <Stack
              sx={{
                minHeight: 0,
              }}
            >
              <Highlights data={data} />
            </Stack>
            <Stack
              sx={{
                minHeight: 0,
              }}
              flexGrow={1}
            >
              <Analise data={data} />
            </Stack>
          </Stack>

          <Stack>{/* <VarTotais data={data} /> */}</Stack>

          {/* <Stack
            gap={2}
            flexGrow={1}
            direction={{ xs: "column", md: "row" }}
            sx={{
              minHeight: 0,
            }}
          >
            <Graphs data={data} />
          </Stack> */}

          <Stack>
            <Secoes data={data} />
          </Stack>
        </Stack>
      </Stack>
    </ConsultaProvider>
  );
});

export default withMessage(ConsultaVar);
